export default __webpack_public_path__ + "static/media/copyIcon.dd199bb7.svg";